import {parseResponse} from "../api"
import {NOT_NULL_MSG} from '../validation/messages'

export default class CaseService {
  constructor(axios) {
    // todo(egor): add config for domain
    this.axios = axios
  }

  getFilteredCases({skip, limit, filters, sortBy, order}) {
    return this.axios.get('/api/cases/get', {
      params: {
        skip: skip,
        limit: limit,
        sortBy: sortBy,
        order: order,
        filters: filters
      }
    }).then((response) => {
      return parseResponse(response)
    })
  }

  getCase({caseId}) {
    if (!caseId) {
      throw Error("Can't find case with empty id")
    }

    return this.axios.get(`/api/cases/get-info`, {
      params: {
        id: caseId
      }
    })
      .then((response) => {
        return parseResponse(response)
      })
  }

  async updateCaseOverrideInfo({caseId, ...data}) {
    if (!caseId) {
      throw Error("Can't find case with empty id")
    }

    return this.axios.post(`/api/cases/update-override-info`, {
      caseId: caseId,
      ...data
    })
      .then((response) => {
        return parseResponse(response)
      })
  }

  async getCaseSlideStainForService({caseId}) {
    if (!caseId) {
      throw Error(`Wrong caseId: ${NOT_NULL_MSG}`)
    }

    return this.axios
      .get(`/api/cases/slide-stains-for-service?caseId=${caseId}`)
      .then((response) => {
        return parseResponse(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/services/CaseService.js